import { useMap } from '@vis.gl/react-maplibre';
import { useEffect } from 'react';

const SPRITE_ID = 'mpris';

export function MapSprite() {
  const { current: map } = useMap();

  useEffect(() => {
    if (!map) return () => {};

    const spriteUrl = `${document.location.origin}/tiles/sprite/icons`;

    const addSprite = () => {
      if (!map.getStyle()) return;

      const existingSprite = map.getSprite().find((sprite) => sprite.id === SPRITE_ID);
      if (existingSprite?.url === spriteUrl) return;

      map.addSprite(SPRITE_ID, spriteUrl);
    };

    map.on('style.load', addSprite);
    addSprite();

    return () => {
      map.off('style.load', addSprite);
    };
  }, [map]);

  return null;
}
